<template>
<div class="k_overview" style="height:100%;overview:auto">
    <div class="kTopBox">
        <el-row class="title">
            待处理事项<span>
                <!-- <i class="el-icon-date"></i>更新时间：2020-11-15 -->
            </span>
        </el-row>
        <el-row class="content" type="flex">
            <el-row class="flex-column conBox" type="flex" align="middle" @click.native="jumpOrderPage('/ddlb',1)">
                <b>{{formData.order && formData.order[1] ? formData.order[1] : 0}}</b>
                <span>待付款订单</span>
            </el-row>
            <el-row class="flex-column conBox" type="flex" align="middle" @click.native="jumpOrderPage('/ddlb',2)">
                <b>{{formData.order && formData.order[2] ? formData.order[2] : 0}}</b>
                <span>待发货</span>
            </el-row>
            <el-row class="flex-column conBox" type="flex" align="middle" @click.native="jumpOrderPage('/ddlb',3)">
                <b>{{formData.order && formData.order[3] ? formData.order[3] : 0}}</b>
                <span>待收货</span>
            </el-row>
            <el-row class="flex-column conBox" type="flex" align="middle" @click.native="jumpPage('/cashout')">
                <b>{{formData ? formData.withdrawal : 0}}</b>
                <span>待处理提现申请</span>
            </el-row>
        </el-row>

        <el-row class="title">快捷功能</el-row>
        <el-row class="kj_content" type="flex">
            <el-row class="kjText flex-column" type="flex" align="middle" @click.native="jumpPage('/bjspAdd')">
                <i class="el-icon-plus" style="color:#3EA740;font-size:28px"></i>
                <span>新增会员区商品</span>
            </el-row>
            <el-row class="kjText flex-column" type="flex" align="middle" @click.native="jumpPage('/spAdd')">
                <i class="el-icon-plus" style="color:#3EA740;font-size:28px"></i>
                <span>新增自营区商品</span>
            </el-row>
            <el-row class="kjText flex-column" type="flex" align="middle" @click.native="jumpPage('/splb')">
                <i class="el-icon-message-solid" style="color:#F8AC59;font-size:28px"></i>
                <span>新增秒杀</span>
            </el-row>
            <el-row class="kjText flex-column" type="flex" align="middle" @click.native="jumpPage('/ydspAdd')">
                <i class="el-icon-plus" style="color:#3EA740;font-size:28px"></i>
                <span>新增银豆商品</span>
            </el-row>
            <el-row class="kjText flex-column" type="flex" align="middle" @click.native="jumpPage('/tdspAdd')">
                <i class="el-icon-plus" style="color:#3EA740;font-size:28px"></i>
                <span>新增铜豆商品</span>
            </el-row>
        </el-row>

        <el-row class="title" type="flex" align="middle">
            数据看板
            <label style="margin-left:auto;font-size:14px;color:#333;font-weight:100">时间筛选：</label>
            <div>
                <TimeSelector :time-type="select.timeType" :time-date="select.timeDate" @success="handleTimeChange"></TimeSelector>
            </div>
            <!-- <el-select v-model="day" filterable placeholder="请选择" size="mini" @change="getList()">
                <el-option v-for="item in timeArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select> -->
        </el-row>
        <el-row class="flex flex-wrap sj_content">
            <el-row type="flex" class="flex-column kjText" @click.native="handleJump('/ddlb')">
                <span>成交订单数</span>
                <b>{{formData.three && formData.three.deal_count ? formData.three.deal_count : 0}}</b>
            </el-row>
            <el-row type="flex" class="flex-column kjText" @click.native="handleJump('/ddlb')">
                <span>成交订单金额</span>
                <b>{{formData.three && formData.three.deal_amount ? formData.three.deal_amount : 0}}</b>
            </el-row>
            <el-row type="flex" class="flex-column kjText" @click.native="handleJump('/ddlb')">
                <span>退款订单数</span>
                <b>{{formData.three && formData.three.back_count ? formData.three.back_count : 0}}</b>
            </el-row>
            <el-row type="flex" class="flex-column kjText" @click.native="handleJump('/ddlb')">
                <span>退款金额</span>
                <b>{{formData.three && formData.three.back_amount ? formData.three.back_amount : 0}}</b>
            </el-row>
            <el-row type="flex" class="flex-column kjText" @click.native="handleJump('/ddlb')">
                <span>付款会员数</span>
                <b>{{formData.three && formData.three.pay_user_count ? formData.three.pay_user_count : 0}}</b>
            </el-row>
        </el-row>
    </div>
</div>
</template>

<script>
// var echarts = require('echarts');
import TimeSelector from '@/components/TimeSelector';
import moment from 'moment';
export default {
    components: {
        TimeSelector
    },
    data() {
        return {
            formData: {},
            timeArr: [{
                id: 7,
                name: '近7天'
            }, {
                id: 30,
                name: '近30天'
            }, {
                id: 60,
                name: '近60天'
            }, {
                id: 90,
                name: '近90天'
            }],
            day: 7,
            select:{
                timeType:'year',
                timeDate:moment().format("YYYY-MM-DD")
            }
        }
    },

    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            this.http.post('/admin/admin/survey', this.select).then((response) => {
                this.formData = response;
            })
        },

        jumpPage: function(path) {
            this.$router.push(path)
        },

        jumpOrderPage: function(path, state) {
            this.$router.push({
                path: path,
                query: {
                    status_id: state
                }
            })
        },

        handleJump(path){
            this.$router.push(path)
        },

        handleTimeChange(type, time) {
            this.select.timeType = type;
            this.select.timeDate = time;
            this.getList()
        }
    }
}
</script>
<style lang="less" scoped>
.k_overview {
    overflow: auto !important;
}
</style>
